import { render } from "./SignupPageCMS.vue?vue&type=template&id=7f80f69a"
import script from "../js/signup-page-cms.js?vue&type=script&lang=js"
export * from "../js/signup-page-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__